<template>
    <div class="textMessage">
        <div class="messageTitle">
            <p @click="addMessage('add')">创建短信模板</p>
        </div>
        <div class="tableBox">
            <el-table :data="tableData">
                <el-table-column :resizable="false" prop="templateName" label="模版名称" align="center" width="200"></el-table-column>
                <el-table-column :resizable="false" prop="templateApplyType" label="模版应用" align="center" width="90"></el-table-column>
                <el-table-column :resizable="false" prop="templateContent" label="短信内容" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="createdTime" label="申请时间" align="center" width="160"></el-table-column>
                <el-table-column :resizable="false" prop="templateStatusText" label="状态" align="center" width="90"></el-table-column>
                <el-table-column :resizable="false" label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <!-- 不通过 -->
                        <div class="btnBox" v-if="scope.row.templateStatus == 1">
                            <span size="mini" tyspan="text" @click="addMessage(scope.row)">修改</span>
                            <span size="mini" tyspan="text" @click="handleTextClick(scope.row)">查看原因</span>
                        </div>
                        <!-- 通过 -->
                        <div v-if="scope.row.templateStatus == 2">
                            <span size="mini" tyspan="text" @click="handleTextClick(scope.row)">{{ scope.row.testStatusText }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="bottom-paginations" v-if="totalSize > 9">
            <el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageLimit" layout="prev, pager, next, jumper" :total="totalSize"></el-pagination>
        </div>
        <el-dialog class="dialog" :title="disabled ?  '修改短信模板' : '创建短信模板'" :visible.sync="dialogVisible" top="15vh" width="600px" :before-close="handleClose">
            <div class="templateName">
                <div class="nameTitle">模板名称：</div>
                <el-input v-model="templateName" :maxlength="15" placeholder="卡券赠送提醒（15字之内）" />
            </div>
            <div class="templateName">
                <div class="nameTitle">短信应用：</div>
                <el-radio v-model="radio" :label="1" @input="radioBtn">问候短信</el-radio>
                <el-radio v-model="radio" :label="2" @input="radioBtn">卡券赠送</el-radio>
            </div>
            <div class="templateName">
                <div class="nameTitle">设置变量：</div>
                <div class="btn" @click="copyBtn('${name}')">复制变量：${name}</div>
                <div class="btn" v-if="radio == 2" @click="copyBtn('${amount}')">复制变量：${amount}</div>
            </div>
            <div class="tips">提示： ${name}表示球馆名称 和 ${amount}表示卡券金额</div>
            <div class="templateName">
                <div class="nameTitle">模版内容：</div>
                <el-input type="textarea" :rows="3" :placeholder="tipsText" v-model="textarea" maxlength="50" show-word-limit />
            </div>
            <div class="btnBox">
                <p class="subBtn" @click="subBtn">{{ disabled ?  '修改' : '创建'}}</p>
            </div>
        </el-dialog>
        <Dialog :title="title" :width="width" ref="getDialog" @subRes="subRes"></Dialog>
    </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
import { copyText } from '../../utils/util'
import Dialog from '../common/dialog.vue'
export default {
    data () {
        return {
            tableData: [],
            dialogVisible: false,
            dialogVisibleInfo: false,
            dialogVisibleText: false,
            currentPage: 1,
            pageLimit: 10,
            totalSize: 0,
            billiardsId: JSON.parse(localStorage.billiardsInfo).billiardsId,
            templateName: '',
            textarea: '',
            radio: 1,
            tipsText: '哈喽～想你的365天，日日夜夜念着你～感谢您对${name}的支持，希望您常来光顾，祝您生活愉快～',
            title: '',
            width: '400px',
            disabled: false,
            type: '',
            marketingSmsTemplateId: 0
        }
    },
    components: {
        Dialog
    },
    created () {
        this.getData()
    },
    methods: {
        subRes () {
            this.getData()
        },
        handleInfoClick (item) {
            console.log(item);
            this.dialogVisibleInfo = true
        },
        handleTextClick (item) {
            if (item.templateStatus == 1) {
                this.title = '查看失败原因'
                this.$nextTick(() => {
                    this.$refs.getDialog.getInit(item)
                })
            } else {
                switch (item.testStatus) {
                    case 0:
                        this.title = '请输入手机号进行测试'
                        this.$nextTick(() => {
                            this.$refs.getDialog.getInit(item)
                        })
                        break;
                    case 1:
                        this.$message({ type: 'success', message: '测试已通过，无需多次提交' })
                        break;
                    case 2:
                        this.title = '查看失败原因'
                        this.$nextTick(() => {
                            this.$refs.getDialog.getInit(item)
                        })
                        break;
                }
            }

        },
        radioBtn (val) {
            this.textarea = ''
            val == 1 ? this.tipsText = '哈喽～想你的365天，日日夜夜念着你～感谢您对${name}的支持，希望您常来光顾，祝您生活愉快～' : this.tipsText = '恭喜获得${amount}元优惠券，请前往KO台球APP或小程序“我的-优惠券”里查看'
            console.log(val);
        },
        copyBtn (val) {
            copyText(this, val)
            this.textarea = this.textarea + val
        },
        async getData () {
            const data = await response(requstsMethod.fun_Get_authorized_marketing_wake_sms_page, {
                billiardsId: this.billiardsId,
                pageNo: this.currentPage,
                pageLimit: this.pageLimit,
            })
            if (data.list) {
                console.log(data, 'datadata');
                data.list.map(item => {
                    item.templateApplyType == 1 ? item.templateApplyType = '问候' : item.templateApplyType = '发券'
                    switch (item.templateStatus) {
                        case 0:
                            item.templateStatusText = '申请中'
                            break;
                        case 1:
                            item.templateStatusText = '不可用'
                            break;
                        case 2:
                            item.templateStatusText = '可用'
                            break;
                    }
                    switch (item.testStatus) {
                        case 0:
                            item.testStatusText = '测试'
                            break;
                        case 1:
                            item.testStatusText = '测试成功'
                            break;
                        case 2:
                            item.testStatusText = '测试失败'
                            break;
                    }
                })
                this.tableData = data.list
                this.totalSize = data.total
            }
        },
        // 新增详情
        addMessage (value) {
            this.templateName = ''
            this.radio = 1
            this.textarea = ''
            if (value == 'add') {
                this.dialogVisible = true
                this.disabled = false
            } else {
                this.disabled = true
                this.getSendInfo(value)
            }
        },
        async getSendInfo (item) {
            console.log(item);
            this.marketingSmsTemplateId = item.marketingSmsTemplateId
            const data = await response(requstsMethod.fun_Get_authorized_marketing_wake_sms_detail, { id: item.marketingSmsTemplateId })
            if (data) {
                this.dialogVisible = true
                this.templateName = data.templateName
                this.radio = data.templateApplyType
                this.textarea = data.templateContent
            }
            console.log(data);
        },
        handleClose () {
            this.dialogVisible = false
            this.dialogVisibleInfo = false
            this.dialogVisibleText = false
        },
        async subBtn () {
            if (this.templateName == '') {
                this.$message({ message: '请输入模版名称', type: 'error' });
            } else if (this.textarea == '') {
                this.$message({ message: '请输入模版内容', type: 'error' });
            } else {
                if (this.disabled) {
                    const data = await response(requstsMethod.fun_Get_authorized_marketing_wake_sms_update, {
                        marketingSmsTemplateId: this.marketingSmsTemplateId,
                        billiardsId: this.billiardsId,
                        remark: "-",
                        templateApplyType: this.radio,
                        templateContent: this.textarea,
                        templateName: this.templateName
                    })
                    if (data) {
                        this.$message({ message: '修改成功', type: 'success' });
                        this.dialogVisible = false
                        this.getData()
                    }
                } else {
                    const data = await response(requstsMethod.fun_Get_authorized_marketing_wake_sms_apply, {
                        billiardsId: this.billiardsId,
                        remark: "-",
                        templateApplyType: this.radio,
                        templateContent: this.textarea,
                        templateName: this.templateName
                    })
                    console.log(data);
                    if (data) {
                        this.$message({ message: '创建成功', type: 'success' });
                        this.dialogVisible = false
                        this.getData()
                    }
                }

            }
        },
        handleCurrentChange (val) {
            this.currentPage = val
            this.getData()
        }
    }
}
</script>

<style lang="scss">
.textMessage {
    padding: 20px 10px;
    .messageTitle {
        display: flex;
        justify-content: flex-end;
        padding-right: 20px;
        p {
            padding: 10px 40px;
            letter-spacing: 1px;
            font-weight: 700;
            font-size: 16px;
            color: #fff;
            background-color: #ff8b3e;
            border-radius: 4px;
            cursor: pointer;
        }
    }
    .tableBox {
        min-height: 470px;
        .el-table {
            border: 1px solid #566979;
            background: #4d4d4d;
            margin-bottom: 20px;
            margin-top: 20px;

            .el-table__header-wrapper {
                .el-table__header {
                    thead {
                        tr {
                            th {
                                background: #4d4d4d;
                                color: #fff;
                                border-bottom: 1px solid #566979;
                                border-right: 1px solid #566979;
                                padding: 0 !important;
                                height: 30px;
                                font-size: 12px;

                                .cell {
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                }
            }

            .el-table__body-wrapper {
                .el-table__body {
                    tbody {
                        .el-table__row {
                            height: 40px;

                            td {
                                background: #4d4d4d;
                                color: #fff;
                                border-bottom: 1px solid #566979;
                                border-right: 1px solid #566979;
                                padding: 0 !important;
                                height: 30px;
                                font-size: 12px;
                                .cell {
                                    div {
                                        display: flex;
                                        justify-content: center;
                                        span {
                                            width: 80px;
                                            display: inline-block;
                                            color: #409eff !important;
                                        }
                                    }
                                }
                            }
                        }

                        .el-table__row:hover {
                            td {
                                background: #566979;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }

    .el-table::before {
        background: #3e3e3e !important;
    }
    .bottom-paginations {
        padding: 0px 30px 20px 0;
        margin: 10px 0 20px 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .el-pagination {
            float: right;

            .el-pager {
                .el-icon {
                    background-color: #4d4d4d;
                    color: #fff;
                    box-shadow: 0px 0px 5px #000;
                }

                li:hover {
                    color: #fff !important;
                }

                .el-icon-d-arrow-left:hover {
                    color: #fff;
                }

                .number {
                    background: #4d4d4d;
                    box-shadow: 0px 0px 5px #000;
                    color: #fff;
                }
            }

            .el-pagination__jump {
                color: #fff;
                font-weight: 800;

                .el-input {
                    .el-input__inner {
                        border: none;
                        background: #4d4d4d;
                        border-radius: 2px;
                        box-shadow: 0px 0px 5px #000;
                        color: #fff;
                    }
                }
            }

            .btn-prev {
                height: 30px;
                background: #4d4d4d;
                box-shadow: 0px 0px 5px #000;
                color: #fff;
            }

            .btn-next {
                height: 30px;
                background: #4d4d4d;
                box-shadow: 0px 0px 5px #000;
                color: #fff;
            }
        }

        .enter-button {
            float: right;
            width: 40px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            box-shadow: 0px 0px 5px #000;
            font-size: 14px;
        }
    }
    .dialog {
        background: rgba(0, 0, 0, 0.3);

        .el-dialog {
            box-shadow: 0px 0px 10px #000;
            background: #3e3e3e;

            .el-dialog__header {
                height: 50px;
                line-height: 50px;
                padding: 0;
                background: #3e3e3e;

                .el-dialog__title {
                    color: #fff;
                    font-size: 20px;
                }

                .el-dialog__headerbtn {
                    width: 30px;
                    height: 30px;
                    font-size: 25px;
                    top: 10px;
                    right: 10px;
                    border-radius: 50%;
                    box-shadow: 0px 0px 5px #000;
                    background: #515151;

                    .el-dialog__close {
                        font-weight: 900;
                        color: #fff;
                    }
                }
            }

            .el-dialog__body {
                padding: 0 20px 20px 20px;
                background: #3e3e3e;
                color: #fff;
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                justify-content: flex-start;

                .templateName {
                    display: flex;
                    align-items: flex-start;
                    margin-top: 30px;
                    .nameTitle {
                        letter-spacing: 1px;
                    }
                    .el-input {
                        width: 400px;
                        margin-left: 10px;
                        .el-input__inner {
                            background-color: #3e3e3e;
                            color: #fff;
                            border: none;
                            box-shadow: 0 0 5px #000 inset;
                            font-weight: 600;
                            letter-spacing: 1px;
                        }
                    }
                    .el-radio {
                        margin-left: 10px;
                        color: #fff;
                    }
                    .el-textarea {
                        width: 400px;
                        margin-left: 10px;
                        .el-textarea__inner {
                            background-color: #3e3e3e;
                            color: #fff;
                            border: none;
                            box-shadow: 0 0 5px #000 inset;
                            font-weight: 600;
                            letter-spacing: 1px;
                        }
                        .el-input__count {
                            background: transparent;
                            font-size: 14px;
                        }
                    }
                    .btn {
                        margin-left: 15px;
                        padding: 5px 12px;
                        font-size: 14px;
                        color: #fff;
                        background-color: #3498fb;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                }
                .tips {
                    color: #999;
                    font-size: 14px;
                    margin-top: 10px;
                    margin-left: 30px;
                    display: flex;
                    align-items: flex-start;
                }

                .btnBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    padding-right: 20px;
                    margin: 30px 0 10px;
                    .subBtn {
                        padding: 10px 25px;
                        letter-spacing: 2px;
                        font-size: 16px;
                        font-weight: 800;
                        border-radius: 4px;
                        cursor: pointer;
                        color: #fff;
                        background-color: #409eff;
                    }
                    .subBtn:hover {
                        background-color: #3498fb;
                    }
                }
            }
        }
    }
}
</style>